module.exports = __webpack_public_path__ + "static/media/twitter.133a6b76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/twitter.svg
// module id = 828
// module chunks = 0